import { render, staticRenderFns } from "./AutocompleteFetch.vue?vue&type=template&id=18541f7b&"
import script from "./AutocompleteFetch.vue?vue&type=script&lang=js&"
export * from "./AutocompleteFetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports